import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const WorkHistoryPPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_workhistory, pptx_inc_workhistory_keyonly, pptx_inc_workhistory_jobtitle, pptx_inc_workhistory_timeframe } = state

  return (
    <CVCard
      title={t('CVTemplates.WorkHistory')}
      description={t('CVTemplates.WorkHistoryAndExperience')}
      isEnabled={pptx_inc_workhistory}
      toggleName='pptx_inc_workhistory'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='pptx_inc_workhistory_keyonly'
          label={t('CVTemplates.KeyEmploymentsOnly')}
          value={pptx_inc_workhistory_keyonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_workhistory_jobtitle'
          label={t('CVTemplates.ShowJobTitle')}
          value={pptx_inc_workhistory_jobtitle}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_workhistory_timeframe'
          label={t('CVTemplates.ShowTimeframe')}
          value={pptx_inc_workhistory_timeframe}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
